<template>
    <div class="footer py-4 d-flex flex-lg-column" id="kt_footer">
        <!--begin::Container-->
        <div class="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between">
            <!--begin::Copyright-->
            <div class="text-dark order-2 order-md-1">
                <span class="text-muted fw-bold me-1">{{year}}©</span>
                <a href="//mostranopantanal.com.br" target="_blank" class="text-gray-800 text-hover-primary">{{$page.props.globalVar.nomeMostra}}</a>
            </div>
            <!--end::Copyright-->
        </div>
        <!--end::Container-->
    </div>
</template>

<script>
export default {
    data: _ => ({
        year: moment().year()
    }),
}
</script>
